import React,{useState,useEffect,useRef} from "react";
import css from "./BubblingView.module.css";


export default function BubblingView(props){
    const [coordinates,setCoordinates]=useState();
    const [_,render]=useState(false);
    const state=useRef({
        ref:useRef(),
        width:null,
        geight:null,
        step:100*statics.step*rem,
    }).current,{step}=state;
    useEffect(()=>{
        if(!coordinates){
            const element=state.ref.current,{width,height}=element.getBoundingClientRect();
            state.width=width;
            state.height=height;
            setCoordinates(new Array(statics.bubbleCount).fill().map(()=>[
                (100*Math.random()-Math.random()*statics.offset)*width/window.innerWidth,
                (100*Math.random()-Math.random()*statics.offset)*height/window.innerHeight,
            ]));
        }
        const timeout=setTimeout(()=>{render(!_)},coordinates?statics.duration:0);
        return ()=>{
            clearTimeout(timeout);
        };
    });
    return (
        <div ref={state.ref} className={`${css.bubblingview} ${props.className||""}`}>
            {coordinates?.map((coords,i)=>{
                const x=coords[0]=coords[0]+(Math.random()-0.5)*step/window.innerWidth;
                const y=coords[1]=coords[1]+(Math.random()-0.5)*step/window.innerHeight;
                return <span 
                    key={"bubble"+i}
                    className={css.bubble}
                    style={{
                        transform:`translate(${x}rem,${y}rem) scale(${Math.random()}) ${hasLightTheme?`rotateZ(${360*Math.random()}deg)`:""}`,
                        transitionDuration:`${statics.duration}ms`,
                    }}
                />
            })}
        </div>
    )
}

const statics={
    get offset(){
        if(window.hasLightTheme) return 20;
        else return 0;
    },
    get bubbleCount(){
        if(window.hasLightTheme) return window.innerWidth<567?100:200;
        else return window.innerWidth<567?200:300;
    },
    get duration(){
        if(window.hasLightTheme) return 4000;
        else return 2000;
    },
    step:8,
}
